// extracted by extract-css-chunks-webpack-plugin
module.exports = {"swiper":"swiper_3X4_W","fadeInImg":"fadeInImg_1nA-A"};